<h2 class="mat-title">
  <ng-content></ng-content>
</h2>
<span *ngIf="closeButton" (click)="close.emit()" class="mat-primary font-12 cursor-pointer">
  <mat-icon inline class="vertical-align-middle">close</mat-icon>
  <ng-container *ngIf="closeText"> {{ closeText }} </ng-container>
</span>
